
define('ldsh!modules/duplicate_control/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-form-group col one-half pb-checks-integration">\n  <label for="on_duplicated_key" data-i18n="integration.mdirectorAllowUpdatingContact"></label>\n  <select class="ed-form-control ed-form-item-full" id="on_duplicated_key" name="on_deleted_key">\n    <option value="ignore"\n            data-i18n="common.duplicatedOptions.dontDoAnything"\n            ' +
((__t = ( this.model.get('on_duplicated_key') === 'ignore' ? 'selected' : '' )) == null ? '' : __t) +
' >\n    </option>\n    <option value="update"\n            data-i18n="common.duplicatedOptions.update"\n            ' +
((__t = ( this.model.get('on_duplicated_key') === 'update' ? 'selected' : '' )) == null ? '' : __t) +
' >\n    </option>\n    <option value="error"\n            data-i18n="common.duplicatedOptions.error"\n            ' +
((__t = ( this.model.get('on_duplicated_key') === 'error' ? 'selected' : '' )) == null ? '' : __t) +
' >\n    </option>\n  </select>\n</div>\n';
 if (this.model.get('on_duplicated_key') === 'error') { ;
__p += '\n<div class="ed-form-group col one-half duplicateControlErrorMessage">\n  <label for="error_message_for_duplicate_control" class="errorColumnRight">\n    <span data-i18n="integration.mdirectorErrorUpdatingContact"></span>\n  </label>\n  <textarea class="ed-form-control ed-form-item-full textarea-message-allow-updating"\n            id="error_message_for_duplicate_control"\n            name="errorMessageForDuplicateControl">' +
__e(this.model.get('error_message')) +
'</textarea>\n  <span class="help-block hidden js-error-duplicated-message"></span>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

